import React from 'react';
import PropTypes from 'prop-types';
import InlineCss from 'react-inline-css';
import SignatureArea from './SignatureArea';
import ContractLogo from './ContractLogo';
import ServicesAndPayment from './ServicesAndPayment';
import INLINE_STYLES from './inline-styles';

const createMarkup = contract => ({
  __html: (contract.termsHTML && `${contract.termsHTML}`) || '<div />',
});

const ContractComponent = ({ contract, componentType }) => (
  <InlineCss stylesheet={INLINE_STYLES(componentType)}>
    <div className="contract-component">
      <div className="title-wrapper">
        <ContractLogo organization={contract.organization} />
      </div>
      <div className="contract-html" dangerouslySetInnerHTML={createMarkup(contract)} />
      <ServicesAndPayment contract={contract} />
      <SignatureArea contractFlow={contract} />
    </div>
  </InlineCss>
);

ContractComponent.propTypes = {
  contractFlow: PropTypes.object,
  componentType: PropTypes.oneOf(['pdf', 'html']),
  'contractFlow.termsHTML': PropTypes.string,
};

// Specifies the default values for props:
ContractComponent.defaultProps = {
  contractFlow: {},
  'contractFlow.termsHTML': '<div />',
  componentType: 'html',
};

export default ContractComponent;



// WEBPACK FOOTER //
// ./src/components/common/ContractComponent/index.js